module.exports = __webpack_public_path__ + "549f61d691d7775a8b091081a92649c5.png";